// Light or dark. The choice lives in localStorage 'color-theme' (the key the portal has always
// used, so existing preferences carry over) and shows as the .dark class on <html>. The layout
// sets the class before first paint; this wires up the toggle buttons.
import { $$ } from './dom';

const KEY = 'color-theme';

export function isDark(): boolean {
	return document.documentElement.classList.contains('dark');
}

export function setDark(dark: boolean): void {
	document.documentElement.classList.toggle('dark', dark);
	try {
		localStorage.setItem(KEY, dark ? 'dark' : 'light');
	} catch {
		/* private mode */
	}
	syncToggles();
	document.dispatchEvent(new CustomEvent('n:theme', { detail: { dark } }));
}

function syncToggles(): void {
	for (const button of $$('[data-n-theme-toggle]')) {
		button.setAttribute('aria-pressed', String(isDark()));
		const use = button.querySelector('use');
		const href = use?.getAttribute('href');
		if (use && href) use.setAttribute('href', href.replace(/#(sun|moon)$/, isDark() ? '#sun' : '#moon'));
	}
}

export function initTheme(): void {
	document.addEventListener('click', (e) => {
		if ((e.target as Element).closest('[data-n-theme-toggle]')) setDark(!isDark());
	});
	syncToggles();
}
